var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:['side-menu-link', { active: _vm.isActive }],on:{"click":_vm.navigate}},[_c('AppIcon',{attrs:{"icon":_vm.item.icon,"mdi":_vm.item.mdiIcon,"left":""}}),_vm._v(" "+_vm._s(_vm.item.title)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }